const ONE_HOUR = 1000 * 60 * 60;
export const BOX_REFRESH_INTERVAL = ONE_HOUR;
export const BOX_REFRESH_MAX_AGE = ONE_HOUR * 24;
